'use strict';
import {module} from '../app';

module.filter('capitalizeWords', function () {
  return function (input) {
    if (!input) {
      return input;
    }
    return input.replace(/\w+|-/g, function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/capitalizeWords.js